import { Component, Input } from "@angular/core";

@Component({
    selector: "kno2-html-tip",
    template: `
        <nb-card
            class="html-tip m-0 p-0"
            status="basic">
            <nb-card-header class="py-2">{{ title }}</nb-card-header>
            <nb-card-body [innerHTML]="content"></nb-card-body>
        </nb-card>
    `,
    styleUrls: ["./html-tip.component.scss"],
    standalone: false
})
export class HtmlTipComponent {
    @Input() public title = "Tip";
    @Input() public content: string;

    constructor() {}
}
